module.exports = {
  setAllLocations: (state, arr) => {
    state.all = arr
  },
  setCateringLocations: (state, arr) => {
    state.catering = arr
  },
  setSearched: (state, bool) => {
    state.searched = bool
  },
  setAddress: (state, str) => {
    state.address = str
  },
  setPosition: (state, obj) => {
    state.position = obj
  },
  setResults: (state, arr) => {
    state.results = arr
  },
  setDeliveryAddress: (state, obj) => {
    state.deliveryAddress = obj
  },
  setVehicleInfo: (state, obj) => {
    state.vehicleInfo = obj
  },
  setResultsTab: (state, str) => {
    state.resultsTab = str
  },
  setSelectedState: (state, str) => {
    state.selectedState = str
  },
  setSearchType: (state, str) => {
    state.searchType = str
  },
}
